import React from 'react';
import { useTranslation } from 'react-i18next';
import { fDate } from '../../../utils/formatTime';
// @mui
import { Stack, Box, IconButton } from '@mui/material';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
export default function CalendarToolbar(_a) {
    var date = _a.date, onNextDate = _a.onNextDate, onPrevDate = _a.onPrevDate;
    var i18n = useTranslation().i18n;
    return (React.createElement(Stack, { direction: "row", alignItems: "center", justifyContent: "space-between", sx: { p: 1.5 } },
        React.createElement(Stack, { direction: "row", alignItems: "center", spacing: 1 }),
        React.createElement(Stack, { direction: "row", alignItems: "center", spacing: 1 },
            React.createElement(IconButton, { onClick: onPrevDate },
                React.createElement(ChevronLeft, null)),
            React.createElement(Box, { sx: { typography: function (theme) { return theme.customTypography.h6; } } }, fDate(date, 'MMM yyyy', i18n.language)),
            React.createElement(IconButton, { onClick: onNextDate },
                React.createElement(ChevronRight, null))),
        React.createElement(Stack, { direction: "row", alignItems: "center", spacing: 1 })));
}
